import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iWorkFlowGetLigandState {
    response: any;
    pdbResponse: any; // PDB 데이터를 저장하기 위한 새 필드
    isLoading: boolean;
    message: string | null;
    status : number | null; // 응답 상태 코드를 저장할 필드 추가
}

const initialState: iWorkFlowGetLigandState = {
    response: null,
    pdbResponse: null, // PDB 응답을 위한 초기값
    isLoading: false,
    message: "",
    status: null, // 초기값 null
};

// 인터페이스에서 선택적 파라미터를 표시하기 위해 물음표를 추가
export interface WorkflowGetResultDockingLigand {
    group_name: string;
    library_name: string;
    round: number;
    step: number;
    ligand_id?: string; // 선택적 파라미터
    task_name?: string;    // 선택적 파라미터
    backup?: boolean;      // 선택적 파라미터 (use_backup)
    timestamp?: string;    // 선택적 파라미터
    saveToPdbResponse?: boolean; // PDB 응답을 저장할지 여부를 결정하는 플래그
}

export const WorkflowGetResultDockingLigandAPI = createAsyncThunk(
    "WorkflowGetResultDockingLigandAPI",
    async (data: WorkflowGetResultDockingLigand, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/workflow/result-docking-ligand/';
          
            
            // 필수 파라미터만 먼저 설정
            const requestData: any = {
                group_name: data.group_name,
                library_name: data.library_name,
                ligand_id: data.ligand_id,
                round: data.round,
                step: data.step,
                task_name: data.task_name,
            };
            
            if (data.backup !== undefined) {
                requestData.backup = data.backup;
            }
            
            if (data.timestamp !== undefined) {
                requestData.timestamp = data.timestamp;
            }
            
            const response = await axiosInstance.post(`${djangoEndpoint}${pathParam}`, requestData);
            
            // saveToPdbResponse 플래그를 통해 반환 데이터에 메타데이터 추가
            return {
                saveToPdbResponse: data.saveToPdbResponse || false,
                data: response.data,
                status: response.status
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const workflowGetLigandSlice = createSlice({
    name: "workFlowResult",
    initialState,
    reducers: {
        // PDB 응답 데이터를 수동으로 설정하는 액션 추가
        setPdbLigandResponse: (state, action: PayloadAction<any>) => {
            state.pdbResponse = action.payload;
        },
        resetWorkflowResult: (state) => {
            state.response = null;
            state.status = null;
            state.message = "";
            state.isLoading = false;
        },
        resetLigandPdbResponse: (state) => {
            state.pdbResponse = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(WorkflowGetResultDockingLigandAPI.pending, (state) => {
                state.isLoading = true;
                state.status = null; // 요청 중에는 상태 코드 초기화
            })
            .addCase(WorkflowGetResultDockingLigandAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.status = action.payload.status; // 상태 코드 저장
                
                // saveToPdbResponse 플래그에 따라 응답을 적절한 필드에 저장
                if (action.payload.saveToPdbResponse) {
                    state.pdbResponse = action.payload.data;
                } else {
                    state.response = action.payload.data;
                }
            })
            .addCase(WorkflowGetResultDockingLigandAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
                if (typeof action.payload === 'object' && action.payload !== null) {
                    state.message = (action.payload as any).message || "An error occurred";
                    state.status = (action.payload as any).status || null;
                } else {
                    state.message = action.payload as string || "An error occurred";
                }
            });
    }
});

export const { setPdbLigandResponse, resetWorkflowResult , resetLigandPdbResponse} = workflowGetLigandSlice.actions;
export default workflowGetLigandSlice.reducer;